import React from 'react';
import './Home.css';
import Product from './Product';
import 'react-slideshow-image/dist/styles.css';

function Home() {
  return (
    <div>
      <div className="home_container">
        <img
          src="https://www.iengineering.com/wp-content/uploads/2017/07/BUSINESS-PROCESS-MANAGEMENT-Banner.jpg"
          className="home_image"
          alt=""
        />
        {/* <div className="slide-container">
          <Slide>
            <div className="each-slide home_image">
              <div style={{ backgroundImage: `url(${slideImages[0]})` }}>
                <span>Slide 1</span>
              </div>
            </div>
            <div className="each-slide home_image">
              <div style={{ backgroundImage: `url(${slideImages[1]})` }}>
                <span>Slide 2</span>
              </div>
            </div>
            <div className="each-slide home_image">
              <div style={{ backgroundImage: `url(${slideImages[2]})` }}>
                <span>Slide 3</span>
              </div>
            </div>
          </Slide>
        </div> */}
      </div>
      <div className="home_row">
        <Product
          title="Html, Css, JavaScript"
          discription="Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ligula dui, blandit imperdiet velit at, tempus tincidunt justo. Proin a ornare velit, non egestas libero. Nulla facilisi. In sagittis dapibus turpis, porta lacinia sem dictum nec. Phasellus auctor viverra quam, non auctor neque ornare laoreet. Phasellus vel arcu justo. Aenean porta et ligula ut tempus"
          image="https://www.ariuswebstudio.com/images/web-designing-banner.png"
          price="1500$"
          rating="5"
        />
        <Product
          title="Html, Css, JavaScript"
          discription="Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ligula dui, blandit imperdiet velit at, tempus tincidunt justo. Proin a ornare velit, non egestas libero. Nulla facilisi. In sagittis dapibus turpis, porta lacinia sem dictum nec. Phasellus auctor viverra quam, non auctor neque ornare laoreet. Phasellus vel arcu justo. Aenean porta et ligula ut tempus"
          image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTyRuGCcB8Cy7CTzuD4GuGsa77zboTHDVt1Fw&usqp=CAU"
          price="1500$"
          rating="5"
        />
        <Product
          title="Html, Css, JavaScript"
          discription="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Natoque penatibus et magnis dis parturient. Neque convallis a cras semper auctor neque. Proin fermentum leo vel orci porta non. In nisl nisi scelerisque eu ultrices vitae auctor."
          image="https://i.pinimg.com/736x/bc/5b/b8/bc5bb8b2b72f7c9acea8bf2902971f3c.jpg"
          price="1500$"
          rating="5"
        />
        <Product
          title="Html, Css, JavaScript"
          discription="Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ligula dui, blandit imperdiet velit at, tempus tincidunt justo. Proin a ornare velit, non egestas libero. Nulla facilisi. In sagittis dapibus turpis, porta lacinia sem dictum nec. Phasellus auctor viverra quam, non auctor neque ornare laoreet. Phasellus vel arcu justo. Aenean porta et ligula ut tempus"
          image="https://img.freepik.com/free-vector/offline-twitch-banner-concept_23-2148588101.jpg?size=626&ext=jpg"
          price="1500$"
          rating="5"
        />
        <Product
          title="Html, Css, JavaScript"
          discription="Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ligula dui, blandit imperdiet velit at, tempus tincidunt justo. Proin a ornare velit, non egestas libero. Nulla facilisi. In sagittis dapibus turpis, porta lacinia sem dictum nec. Phasellus auctor viverra quam, non auctor neque ornare laoreet. Phasellus vel arcu justo. Aenean porta et ligula ut tempus"
          image="https://s3.envato.com/files/225138083/01_Preview%203.jpg"
          price="1500$"
          rating="5"
        />
      </div>
      <div className="home_row">
        <Product
          title="Html, Css, JavaScript"
          discription="Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ligula dui, blandit imperdiet velit at, tempus tincidunt justo. Proin a ornare velit, non egestas libero. Nulla facilisi. In sagittis dapibus turpis, porta lacinia sem dictum nec. Phasellus auctor viverra quam, non auctor neque ornare laoreet. Phasellus vel arcu justo. Aenean porta et ligula ut tempus"
          image="https://media.phillyvoice.com/media/images/medical-marijuana-pennsylvania.2e16d0ba.fill-735x490.jpg"
          price="1500$"
          rating="5"
        />
        <Product
          title="Html, Css, JavaScript"
          discription="Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ligula dui, blandit imperdiet velit at, tempus tincidunt justo. Proin a ornare velit, non egestas libero. Nulla facilisi. In sagittis dapibus turpis, porta lacinia sem dictum nec. Phasellus auctor viverra quam, non auctor neque ornare laoreet. Phasellus vel arcu justo. Aenean porta et ligula ut tempus"
          image="https://www.shapeglobe.com/wp-content/uploads/2015/12/5-Banner-Shape-Globe-1.jpg"
          price="1500$"
          rating="5"
        />
        <Product
          title="Html, Css, JavaScript"
          discription="Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ligula dui, blandit imperdiet velit at, tempus tincidunt justo. Proin a ornare velit, non egestas libero. Nulla facilisi. In sagittis dapibus turpis, porta lacinia sem dictum nec. Phasellus auctor viverra quam, non auctor neque ornare laoreet. Phasellus vel arcu justo. Aenean porta et ligula ut tempus"
          image="https://lh3.googleusercontent.com/proxy/e2girTl6hyCdLnu2XVmA9-qCnot2uF8fl4IQQmmdn1nNvCD8PzrrMS2hsclM7IohGbPLtMWD_-BKwTyEbNswtFg9pimTxc4PTIyZxbyICr7MdMeoLIM"
          price="1500$"
          rating="5"
        />
      </div>
      <div className="home_row">{/* ptoduct */}</div>
    </div>
  );
}

export default Home;
